<template>
  <base-dropdown v-model="isActive" v-if="isTouchDevice === false" class="fixed bottom-0 right-0 mr-4" placement="top-end" min-width="130">
    <template v-slot:button="{ toggle, identifier }">
      <base-button :id="identifier" :title="$t('label.helpAndMore')" variant="link" :icon-prepend="['fal', 'question-circle']" class="py-1 px-2 bg-white-900 hover:no-underline shadow-surround-default hover:shadow-surround-default" @click.prevent="toggle" />
    </template>
    <div class="flex flex-col py-1">
      <base-button v-if="$hasPermission('Portal.Tickets.Create')" class="block py-1 px-2 text-left" variant="link" @click="onClick('Bug')" :disabled="isCurrentRoute('addTicket')">
        <font-awesome-icon class="mr-1 fa-fw" :icon="['fal', 'bug']" />{{ $t('label.reportBug') }}
      </base-button>
      <base-button v-if="$hasPermission('Portal.Tickets.Create')" class="block py-1 px-2 text-left" variant="link" @click="onClick('InformationRequest')" :disabled="isCurrentRoute('addTicket')">
        <font-awesome-icon class="mr-1 fa-fw" :icon="['fal', 'comment-alt-dots']" />{{ $t('label.giveFeedback') }}
      </base-button>
      <base-button class="block w-full py-1 px-2 text-left" variant="link" @click="showModal">
        <font-awesome-icon class="mr-1 fa-fw" :icon="['fal', 'keyboard']" />{{ $t('shortcuts.shortcuts') }}<span class="inline-block w-6 h-5 text-center bg-light-grey-400 rounded ml-2 hover:no-underline">?</span>
      </base-button>
    </div>
  </base-dropdown>
</template>

<script>
import { isTouchDevice, navigation, shortcut } from '@/mixins/helpers'

import ShortcutsModal from '@/components/Assistance/ShortcutsModal'

export default {
  name: 'Assistance',

  mixins: [ isTouchDevice, navigation, shortcut ],

  data () {
    return {
      isActive: false,
      isModalActive: false
    }
  },

  computed: {
    shortcuts () {
      return [
        { combinations: '?', action: 'keypress', handler: this.showModal }
      ]
    }
  },

  methods: {
    onClick (type) {
      this.isActive = false

      if (this.isCurrentRoute('addTicket') === false) {
        this.$router.push({ name: 'addTicket', params: { type } })
      }
    },

    showModal () {
      if (this.isModalActive === false) {
        this.$store.dispatch('showModal', {
          component: {
            is: ShortcutsModal
          },
          options: {
            title: this.$i18n.t('shortcuts.keyboardShortcuts'),
            size: 'xxl'
          },
          events: {
            close: () => { this.isModalActive = false }
          },
          actions: [{
            onClick: ({ close }) => close(),
            options: {
              title: this.$i18n.t('label.close'),
              variant: 'secondary',
              isPill: true
            }
          }]
        }).then(() => {
          this.isActive = false
          this.isModalActive = true
        })
      }
    }
  }

}
</script>
